import React, { Component } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';

const BlockSVGElement = styled(SVGElement)`
  height: 100%;
  width: 100%;
  display: block;
`;

const HeaderContainer = styled.div`
  position: relative;
  height: ${({ height }) => (height ? `${height};` : null)};
  width: ${({ width }) => (width ? `${width};` : null)};
  overflow-x: hidden;
`;

export default class WindowHeader extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '20px',
    width: '100%',
  };

  render() {
    const { className, height, width } = this.props;

    return (
      <HeaderContainer width={width} height={height}>
        <BlockSVGElement
          className={className}
          viewBox="0 0 1440 20"
          preserveAspectRatio="xMinYMid slice"
        >
          <path fill="#FFF" d="M0 0h1440v20H0z" />
          <g transform="translate(6 6)" fill="#CCC">
            <circle cx="4" cy="4" r="4" />
            <circle cx="32" cy="4" r="4" />
            <circle cx="18" cy="4" r="4" />
          </g>
        </BlockSVGElement>
      </HeaderContainer>
    );
  }
}
